/**common constants for all citing sections */
export var CITING_SECTION_TITLE = "What I'm citing";

/** federal-bill citing section id and testId */
export var FEDERAL_BILL_CITING_SECTION_ID = 'federal-bill-citing-section';
export var FEDERAL_BILL_CITING_SECTION_TEST_ID = 'federal-bill-citing-section-test-id';

/** federal-bill section input test ids */
export var FEDERAL_BILL_TITLE_TEST_ID = 'federal-bill-title-test-id';
export var FEDERAL_BILL_NUMBER_FIELD_TEST_ID = 'federal-bill-number-field-test-id';
export var FEDERAL_BILL_WHICH_CONGRESS_FIELD_TEST_ID = 'federal-bill-which-congress-test-id';

/** radio group options */
export var STATUS_RADIO_INPUT_TEST_ID = 'Status-radio-input-test-id';
export var BILL_TYPE_RADIO_INPUT_TEST_ID = 'Bill-type-radio-input-test-id';
export var FROM_RADIO_INPUT_TEST_ID = 'From-radio-input-test-id';

/** federal-report citing section id and testId */
export var FEDERAL_REPORT_CITING_SECTION_ID = 'federal-report-citing-section';
export var FEDERAL_REPORT_CITING_SECTION_TEST_ID = 'federal-report-citing-section-test-id';

/** federal-report section input test ids */
export var FEDERAL_REPORT_NUMBER_FIELD_TEST_ID = 'federal-report-number-field-test-id';

/** radio group options */
export var TYPE_RADIO_INPUT_TEST_ID = 'Type-radio-input-test-id';

/** federal report labels */
export var NUMBER = 'Number';
export var TYPE = 'Type';
export var FROM = 'From';

/** federal-rule citing section id and testId */
export var FEDERAL_RULE_CITING_SECTION_ID = 'federal-rule-citing-section';
export var FEDERAL_RULE_CITING_SECTION_TEST_ID = 'federal-rule-citing-section-test-id';

/** federal-rule section input test ids */
export var FEDERAL_RULE_TITLE_FIELD_TEST_ID = 'federal-rule-title-field-test-id';
export var FEDERAL_RULE_SECTION_FIELD_TEST_ID = 'federal-rule-section-field-test-id';

/** checkbox with label input id's */
export var FEDERAL_RULE_MULTIPLE_SECTIONS_FIELD_TEST_ID = 'federal-rule-multiple-sections-field-test-id';
export var FEDERAL_RULE_MULTIPLE_SECTIONS_FIELD_CHECKBOX_TEST_ID = 'federal-rule-multiple-sections-field-checkbox-test-id';
export var FEDERAL_RULE_LABEL_TEXT_BOLD = 'Multiple sections';
export var FEDERAL_RULE_LABEL_TEXT = 'Citing more than one section?';

/**federal rule labels */
export var SECTION = 'Section';

/* mailing list citing */
export var MAILING_LIST_SECTION_ID = 'mailing-list-citing-section';
export var MAILING_LIST_TITLE_INPUT_TEST_ID = 'mailing-list-title-input-test-id';
export var MAILING_LIST_DESC_INPUT_TEST_ID = 'mailing-list-description-input-test-id';
export var MAILING_LIST_TITLE_INPUT_LABEL_TEXT = 'Title of post';
export var MAILING_LIST_DESC_INPUT_HELPER_TEXT = 'Ex: Online posting, Mailing List, Email distribution';
export var MAILING_LIST_DESC_INPUT_LABEL_TEXT = 'Description';

/** federal-testimony citing section id and testId */
export var FEDERAL_TESTIMONY_SECTION_ID = 'federal-testimony-citing-section';
export var FEDERAL_TESTIMONY_SECTION_TEST_ID = 'federal-testimony-citing-section-test-id';

/** federal testimony citing section input test ids */
export var FEDERAL_TESTIMONY_TITLE_INPUT_TEST_ID = 'federal-testimony-title-test-id';
export var FEDERAL_TESTIMONY_WHO_TESTIFIED_FIELD_INPUT_TEST_ID = 'federal-testimony-who-testified-test-id';

/** federal testimony citing section labels */
export var WHO_TESTIFIED = 'Who testified';

/** federal-statute citing section id and testId */
export var FEDERAL_STATUTE_CITING_SECTION_ID = 'federal-statute-citing-section';
export var FEDERAL_STATUTE_CITING_SECTION_TEST_ID = 'federal-statute-citing-section-test-id';

/** federal-statute section input test ids */
export var FEDERAL_STATUTE_TITLE_FIELD_TEST_ID = 'federal-statute-title-field-test-id';
export var FEDERAL_STATUTE_CHAPTER_FIELD_TEST_ID = 'federal-statute-chapter-field-test-id';
export var FEDERAL_STATUTE_LAW_NUMBER_FIELD_TEST_ID = 'federal-statute-law-number-field-test-id';
export var FEDERAL_STATUTE_SECTION_START_FIELD_TEST_ID = 'federal-statute-section-start-field-test-id';
export var FEDERAL_STATUTE_SECTION_END_FIELD_TEST_ID = 'federal-statute-section-end-field-test-id';

/** checkbox with label input id's */
export var FEDERAL_STATUTE_OTHER_SECTIONS_FIELD_TEST_ID = 'federal-statute-other-sections-field-test-id';
export var FEDERAL_STATUTE_OTHER_SECTIONS_FIELD_CHECKBOX_TEST_ID = 'federal-statute-other-sections-field-checkbox-test-id';

/** Labels citing section federal statute form */
export var FEDERAL_STATUTE_LABEL_TEXT_BOLD = 'Other sections';
export var FEDERAL_STATUTE_LABEL_TEXT = 'Citing other nonconsecutive sections?';
export var FEDERAL_STATUTE_SECTION_START_HELPER_TEXT = 'Codified: section of source; Uncodified, section of law';

/**federal statute citing section labels */
export var STATUS = 'Status';
export var TITLE = 'Title';
export var CHAPTER = 'Chapter';
export var LAW_NUMBER = 'Law number';
export var SECTION_START = 'Section start';
export var SECTION_END = 'Section end';

/** patent citing section id and testId */
export var PATENT_CITING_SECTION_ID = 'patent-citing-section';
export var PATENT_CITING_SECTION_TEST_ID = 'patent-citing-section-test-id';

/** section input test ids */
export var PATENT_TITLE_INPUT_TEST_ID = 'patent-title-test-id';
export var PATENT_ASSIGNEE_INPUT_TEST_ID = 'patent-assignee-test-id';
export var PATENT_NUMBER_INPUT_TEST_ID = 'patent-number-test-id';

/**patent citing section labels */
export var PATENT_TITLE = 'Patent title';
export var ASSIGNEE = 'Assignee';
export var PATENT_NUMBER = 'Patent number';

/* Map citing section labels */
export var SOURCE_WAS_TITLE = 'Source was';
export var MAP_TITLE_LABEL = 'Map title';

/** write paste section input test ids */
export var WRITE_PASTE_SECTION_TEST_ID = 'write-paste-citing-section-test-id';
export var WRITE_PASTE_TITLE_INPUT_TEST_ID = 'write-paste-title-test-id';

/**Manuscript section labels */
export var WORK_TYPE = 'Work type';
export var SCRIPT_TYPE = 'Script type';
export var STAGE = 'Stage';
export var UNIVERSITY_LOCATION = 'University/location';
export var NUMBER_IF_APPLICABLE = 'Number (if applicable)';
export var COLLECTION = 'Collection';

/** Software citing section labels */
export var SOFTWARE_TITLE = 'Software title';
export var VERSION = 'Version';

/**Reprinted section labels */
export var ARTICLE_TITLE = 'Article title';
export var ORIGINAL_ARTICLE_TITLE = 'Original article title';
export var ORIGINAL_ARTICLE_TITLE_HELPER_TEXT = 'Only fill this in if different from article title.';
export var SOURCE_WAS = 'Source was';

/** Dictionary citing section labels */
export var ENTRY_NAME = 'Entry name';
export var DEFINITION_NUMBER = 'Definition number';

/** Performance citing section labels  */
export var PERFORMANCE_TITLE = 'Performance title';

/** Newsletter citing section labels */
export var NEWSLETTER_TITLE = 'Newsletter title	';
export var DATE_PUBLISHED = 'Date published';
export var VOLUME = 'Volume';
export var PAGE = 'Page';
export var PAGE_HELPERTEXT = 'Ex: 5; 10-15';

/**Dissertation citing section labels */
export var DISSERTATION_TITLE = 'Dissertation title';
export var UNIVERSITY = 'University';
export var YEAR_GIVEN = 'Year given';
export var UMI_NUMBER = 'UMI number	';

/**Microform citing section */
export var ARTICLE_SECTION_TITLE = 'Article / section title';